import React from "react";
import LanguageSelectBody from "../LanguageSelector/LanguageSelect";

export enum DIALOG {
  Language,
}

export const DialogFactory = (dialogType = DIALOG.Language, metaData = {}) => {
  switch (dialogType) {
    case DIALOG.Language:
      return <LanguageSelectBody {...metaData} />;
    default:
      return null;
  }
};
